import { render, staticRenderFns } from "./ProductAttributes.vue?vue&type=template&id=8f970ef0&scoped=true&lang=pug&"
import script from "./ProductAttributes.vue?vue&type=script&lang=js&"
export * from "./ProductAttributes.vue?vue&type=script&lang=js&"
import style0 from "./ProductAttributes.vue?vue&type=style&index=0&id=8f970ef0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f970ef0",
  null
  
)

/* custom blocks */
import block0 from "./ProductAttributes.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports